import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-196a57b4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "editor-node-loader"
};
const _hoisted_2 = {
    key: 1,
    class: "signer-details-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedSpinner = _resolveComponent("FriedSpinner");
    const _component_FriedH3 = _resolveComponent("FriedH3");
    const _component_ContractLinkHeader = _resolveComponent("ContractLinkHeader");
    const _component_DescriptionInput = _resolveComponent("DescriptionInput");
    const _component_SignerDetails = _resolveComponent("SignerDetails");
    const _component_EditorNodeWrapper = _resolveComponent("EditorNodeWrapper");
    return (_openBlock(), _createBlock(_component_EditorNodeWrapper, {
        class: _normalizeClass([
            'node-container',
            'contract-link-container',
            _ctx.rowTypeClass,
            _ctx.blockWidthClass,
            {
                'parent-first-child': _ctx.parentFirstChild,
                'parent-last-child': _ctx.parentLastChild,
            },
        ]),
        onObserveNodeVisibility: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('observe-node-visibility', Object.assign(Object.assign({}, $event), { nodeId: _ctx.node.id }))))
    }, {
        default: _withCtx(() => [
            (_ctx.showContractDetails && _ctx.contractLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_FriedSpinner, { size: 48 }),
                    _createVNode(_component_FriedH3, null, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.loadingContractText), 1)
                        ]),
                        _: 1
                    })
                ]))
                : _createCommentVNode("", true),
            (_ctx.contract)
                ? (_openBlock(), _createBlock(_component_ContractLinkHeader, {
                    key: 1,
                    class: "view",
                    status: _ctx.contractStatus,
                    expired: _ctx.contractExpired,
                    "block-width-class": _ctx.blockWidthClass
                }, {
                    title: _withCtx(() => [
                        _createVNode(_component_FriedH3, { class: "contract-title paragraph-large viewer" }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.node.name), 1)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["status", "expired", "block-width-class"]))
                : _createCommentVNode("", true),
            (_ctx.showContractDetails && _ctx.contract)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass(['contract-link-content', _ctx.blockWidthClass])
                }, [
                    (_ctx.showContractDescription)
                        ? (_openBlock(), _createBlock(_component_DescriptionInput, {
                            key: 0,
                            class: "description view",
                            content: _ctx.contractDescription,
                            fields: _ctx.node.fields,
                            "merge-values": _ctx.mergeValues,
                            "default-align": _ctx.NodeAlign.Left,
                            "data-external": "editor-view-contract-link-contract-description-input"
                        }, null, 8, ["content", "fields", "merge-values", "default-align"]))
                        : _createCommentVNode("", true),
                    (_ctx.contract)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            (_ctx.contract.isSelfsign)
                                ? (_openBlock(), _createBlock(_component_SignerDetails, {
                                    key: _ctx.contractSender.id,
                                    "contract-display-settings": _ctx.node.contractDisplaySettings,
                                    role: _ctx.$t('sender'),
                                    title: _ctx.contractSender.title,
                                    "full-name": _ctx.contractSender.fullName,
                                    "company-name": _ctx.senderCompanyName,
                                    email: _ctx.contractSender.email,
                                    status: _ctx.RecipientStatus.Signed,
                                    "contract-status": _ctx.contract.status,
                                    "block-width-class": _ctx.blockWidthClass
                                }, null, 8, ["contract-display-settings", "role", "title", "full-name", "company-name", "email", "status", "contract-status", "block-width-class"]))
                                : _createCommentVNode("", true),
                            (_ctx.filteredRecipients.length)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.filteredRecipients, (signer, index) => {
                                    return (_openBlock(), _createBlock(_component_SignerDetails, {
                                        key: signer.id,
                                        "is-signing-order": _ctx.contract.isSigningOrder,
                                        "signing-page-url": _ctx.getSigningPageUrlForRecipient(signer.id),
                                        "contract-display-settings": _ctx.node.contractDisplaySettings,
                                        role: _ctx.translatedRole(signer.role),
                                        title: signer.title,
                                        "prev-signer": _ctx.getPreviousSigner(index),
                                        "full-name": signer.fullName,
                                        "company-name": signer.companyName,
                                        email: signer.email,
                                        status: signer.status,
                                        "order-num": signer.orderNum,
                                        "block-width-class": _ctx.blockWidthClass,
                                        "contract-expired": _ctx.contractExpired
                                    }, null, 8, ["is-signing-order", "signing-page-url", "contract-display-settings", "role", "title", "prev-signer", "full-name", "company-name", "email", "status", "order-num", "block-width-class", "contract-expired"]));
                                }), 128))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ], 2))
                : _createCommentVNode("", true)
        ]),
        _: 1
    }, 8, ["class"]));
}
